import { useState } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";
import { downloadCsv } from "@/lib/download";
import { useI18n } from "@/context/I18nContext";
import { Card, Btn } from "@/components/portal/ui";

const LABELS = {
  providers: { de: "Anbieter", fr: "Prestataires", it: "Fornitori", en: "Providers" },
  customers: { de: "Kunden", fr: "Clients", it: "Clienti", en: "Customers" },
  inquiries: { de: "Anfragen", fr: "Demandes", it: "Richieste", en: "Inquiries" },
  packages: { de: "Pakete", fr: "Forfaits", it: "Pacchetti", en: "Packages" },
  subscriptions: { de: "Abos", fr: "Abonnements", it: "Abbonamenti", en: "Subscriptions" },
  invoices: { de: "Rechnungen", fr: "Factures", it: "Fatture", en: "Invoices" },
  documents: { de: "Dokumente", fr: "Documents", it: "Documenti", en: "Documents" },
  activity_log: { de: "Aktivität", fr: "Activité", it: "Attività", en: "Activity" },
  security_log: { de: "Sicherheit", fr: "Sécurité", it: "Sicurezza", en: "Security" },
};

// scope: "control" (cross-portal) or "portal" (single tenant via api default portal_key)
export function ExportBar({ basePath, entities, portalKey }) {
  const { L } = useI18n();
  const [busy, setBusy] = useState(null);

  const dl = async (e) => {
    setBusy(e);
    try {
      const qs = portalKey ? `?portal_key=${encodeURIComponent(portalKey)}` : "";
      const name = `${portalKey ? portalKey + "_" : ""}${e}_${new Date().toISOString().slice(0, 10)}.csv`;
      await downloadCsv(`${basePath}/${e}${qs}`, name);
    } catch (err) {
      toast.error(L({ de: "Export fehlgeschlagen", fr: "Échec de l'export", it: "Esportazione fallita", en: "Export failed" }));
    } finally {
      setBusy(null);
    }
  };

  return (
    <Card className="p-4" data-testid="export-bar">
      <div className="text-sm font-semibold mb-1 flex items-center gap-2" style={{ color: "var(--text)" }}>
        <Download className="h-4 w-4" style={{ color: "var(--accent)" }} />
        {L({ de: "CSV-Export", fr: "Export CSV", it: "Esporta CSV", en: "CSV export" })}
      </div>
      <p className="text-xs mb-3" style={{ color: "var(--text-muted)" }}>
        {L({ de: "Daten als CSV herunterladen (Excel-kompatibel, ; getrennt).", fr: "Télécharger en CSV (compatible Excel, séparé par ;).", it: "Scarica in CSV (compatibile Excel, separato da ;).", en: "Download data as CSV (Excel-friendly, ; separated)." })}
      </p>
      <div className="flex flex-wrap gap-2">
        {entities.map((e) => (
          <Btn key={e} variant="soft" className="h-9 px-3 text-xs" data-testid={`export-${e}`}
            disabled={busy === e} onClick={() => dl(e)}>
            <Download className="h-3.5 w-3.5" /> {L(LABELS[e] || { de: e })}
          </Btn>
        ))}
      </div>
    </Card>
  );
}
